import { render, staticRenderFns } from "./ListingEpisodeSponsoring.vue?vue&type=template&id=47d4c024&scoped=true"
import script from "./ListingEpisodeSponsoring.vue?vue&type=script&lang=js"
export * from "./ListingEpisodeSponsoring.vue?vue&type=script&lang=js"
import style0 from "./ListingEpisodeSponsoring.vue?vue&type=style&index=0&id=47d4c024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d4c024",
  null
  
)

export default component.exports